import { DataAttributeForTesting } from "./Input";

type ButtonProps = {
  loading?: boolean;
  disabled?: boolean;
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
  testId?: DataAttributeForTesting;
};

const Button = ({
  loading,
  onClick,
  children,
  disabled,
  testId,
}: ButtonProps) => {
  return (
    <button
      data-testid={testId}
      disabled={loading || disabled}
      onClick={onClick}
      type="submit"
      className={`bg-red-500 w-full rounded-lg py-3 mt-8 font-bold text-white mx-auto disabled:cursor-not-allowed disabled:bg-red-200 transition-all duration-200 ${disabled ? "bg-red-200" : "bg-red-500"}`}
    >
      {children}
    </button>
  );
};

export default Button;
